import {Component} from 'preact';
import cx from 'classnames';
import pick from 'ramda/src/pick';
import equals from 'ramda/src/equals';
import {ReviewsApiContainer} from '@containers/CustomerReviews/api';
import {Message, TruncateText} from '@ultradent/components';
import format from 'date-fns/format';
import RatingStars from '@components/common/RatingStars';
import ReviewStatus from '../ReviewStatus';
import ReviewComment from '../ReviewComment';
import UserActions from '../UserActions';
import ModeratorActions from '../ModeratorActions';

const i18nText = upi.i18n.getTextFromKey;
const wrdUnknown = i18nText( 'wrd-unknown' );
const lblVerifiedPurchase = i18nText( 'lbl-verifiedPurchase' );
const lblUpVoteError = i18nText( 'lbl-upVoteError' );

class Review extends Component {

    shouldComponentUpdate ( nextProps, nextState, nextContext ) {
        const propList = ['status', 'hasVoted', 'response'];
        return !equals(
            pick( propList, nextProps ),
            pick( propList, this.props )
        );
    }

    getRedirectURL = () => {
        const {index, reviewId, filters = {}} = this.props;
        const pageIndex = Math.floor( index / this.context.requestCount );
        const filtersList = Object
            .entries( filters )
            // exclude default filters
            .filter( f => !f[1].toLowerCase().includes( 'all' ) )
            .map( f =>
                `reviewFilters[]=${f.join( ',' ).toLowerCase()}`
            );

        let redirectURL = `${window.location.pathname}?reviewPageIndex=${pageIndex}`;

        if ( filtersList.length ) {
            redirectURL += `&${filtersList.join( '&' )}`;
        }

        redirectURL += `#customer-review-${reviewId}`;
        return encodeURIComponent( redirectURL );
    };

    render ( props, state, context ) {
        const {
            // brandId,
            createdDate,
            customerId,
            deniedReasonId,
            otherDeniedReason,
            purchaseDate,
            rating,
            reviewBody,
            reviewerName,
            reviewerEmail,
            reviewId,
            product,
            status,
            title
        } = props;

        const user = context.user || {};
        const isReviewModerator = user.isReviewModerator || false;
        const submissionDateFormatted = format(
            createdDate ? new Date( createdDate ) : new Date(),
            'MMMM dd, yyyy'
        );
        const verifiedPurchaseDateFormatted = purchaseDate && format(
            purchaseDate ? new Date( purchaseDate ) : new Date(),
            'MMMM dd, yyyy'
        );
        const reviewContentClasses = cx( {'opacity-50 pointer-events-none': status === 2} );
        const userContentClasses = 'max-w-xs md:max-w-sm lg:max-w-md text-base whitespace-pre-wrap break-words';

        return (
            <ReviewsApiContainer render={( {updateReviewStatus, updateReviewVotes} ) =>
                <div id={`customer-review-${reviewId}`}
                     className="my-4 md:my-10 p-4 -mr-4 -ml-4 on-hover-bordered" data-testid="test-review">
                    <div className={reviewContentClasses}>
                        <h1>{title}</h1>
                        <div className="flex flex-col md:flex-row mb-4">
                            <RatingStars rating={rating}/>
                            {product ?
                                <h4 className="font-normal md:ml-4">{
                                    product.kitName || wrdUnknown}
                                </h4>
                                : null
                            }
                            {verifiedPurchaseDateFormatted ?
                                <span className="md:self-center md:ml-4">
                                    <small>
                                        <strong className="success">
                                            {lblVerifiedPurchase}
                                        </strong> | {verifiedPurchaseDateFormatted}
                                    </small>
                                </span>
                                : null
                            }
                        </div>

                        <TruncateText
                            className={userContentClasses}
                            maxCharacters={720}>
                            {reviewBody}
                        </TruncateText>

                        <ReviewComment isReviewModerator={isReviewModerator} {...props}/>
                    </div>

                    <div className="md:flex w-full justify-between my-4">
                        <div className="mb-4 md:mb-0 flex-1 self-end">
                            <span className="inline-block">
                                By {reviewerName} &ndash; {submissionDateFormatted}
                            </span>
                            {isReviewModerator && reviewerEmail &&
                                <a className="link-2 block" href="mailto:{reviewerEmail}">{reviewerEmail}</a>
                            }
                        </div>
                        {isReviewModerator ?
                            <ReviewStatus
                                className="max-w-sm"
                                deniedReasonId={deniedReasonId}
                                otherDeniedReason={otherDeniedReason}
                                status={status}/>
                            : null
                        }
                    </div>

                    <div className="md:flex mt-4">
                        <UserActions
                            isOwn={user.customerId === customerId}
                            getRedirectURL={this.getRedirectURL}
                            updateReviewVotes={updateReviewVotes}
                            {...props} />

                        {isReviewModerator ?
                            <ModeratorActions
                                updateReviewStatus={updateReviewStatus}
                                {...props} />
                            : null
                        }
                    </div>
                    {updateReviewStatus.result.error &&
                        <Message className="mt-4 rounded" fail>
                            There was a problem while trying to update the status of this review, please try again.
                        </Message>
                    }
                    {updateReviewVotes.result.error &&
                        <Message className="mt-4 rounded" fail>
                            {lblUpVoteError}
                        </Message>
                    }
                </div>
            }/>
        );
    }
}

export default Review;